import React from "react";
import { Link } from "react-scroll";
import "./Need.scss";

const Need = () => {
  return (
    <div className="need-container">
      <h2 className="need-title">Czy potrzebujesz tego kursu?</h2>
      <div className="need-content">
        <div className="need-text">
          <p>
            <b>
              Bez tego kursu możesz żyć :)
              <br /> <br />
              Jeśli jednak:
            </b>
          </p>
          <ul className="need-list">
            <li>
              <span className="check-icon">✔</span>świadczysz usługi IT dla
              małej lub średniej firmy?
            </li>
            <li>
              <span className="check-icon">✔</span> Twój problem to mało czasu i
              środków finansowych?
            </li>
            <li>
              <span className="check-icon">✔</span> chcesz poszerzyć wiedzę i
              poznać praktyczne rozwiązania?
            </li>
            <li>
              <span className="check-icon">✔</span> chciałbyś wsparcia w Twojej
              codziennej pracy?
            </li>
            <li>
              <span className="check-icon">✔</span> masz potrzebę sprawnego
              wdrazania skutecznych rozwiązań?
            </li>
            <li>
              <span className="check-icon">✔</span> chcesz samodzielnie wybierać
              kiedy i jak szybko się uczyć?
            </li>
            <li>
              <span className="check-icon">✔</span> szukasz nie-chmurowych
              rozwiązań dopasowanych do polskich realiów?
            </li>
          </ul>
        </div>
      </div>
      <div className="need-footer">
        <p className="need-highlight">
          To tak! Ten kurs jest skrojony właśnie na Twoje potrzeby!
        </p>
      </div>
      <br />
      <div className="need-text2">
        <br />
        Moim celem był kurs nie tylko profesjonalny, ale przede wszystkim
        praktyczny i pełen wartościowych treści, które od razu będziesz mógł
        wykorzystać w swojej pracy. <br />
        <br />
        {/* <p className="need-price">
          Czy chcesz poznać <span className="highlight">cenę</span>?
        </p>
        <Link to="price" smooth={true} duration={500} className="need-button">
          POKAŻ CENĘ KURSU
        </Link> */}
      </div>
      <h2 className="need-title">
        {" "}
        Teraz z dumą oddaję w Twoje ręce kompleksowe narzędzie, które pomoże Ci
        wspiąć się na wyższy poziom zawodowy.
      </h2>
    </div>
  );
};

export default Need;
